import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, tap } from 'rxjs';

import { OFFER_SERVER_URL } from '../../config';
import { TemplateVariableValues, FieldValueObject, UfoProductSimulationResponse,
	ProductConfiguration } from '../models/product';
import { TranslationType, DataWithTranslation } from '../models/data-with-translations';

import {
	ProductCharacteristicsTranslationService
} from './product-characteristics-translation.services';

const SIMULATE_CONFIGURATIONS_URL = `${ OFFER_SERVER_URL }/configurations:simulateProductConfiguration`;

const PRODUCT_TEMPLATE_URL = `${ OFFER_SERVER_URL }/v3/templates`;
const CONFIGURATIONS_URL = `${ OFFER_SERVER_URL }/configurations`;

@Injectable({ providedIn: 'root' })
export class ConfigurationService {
	constructor(
		private readonly http: HttpClient,
		private readonly productCharacteristicsTranslationService: ProductCharacteristicsTranslationService
	) {}

	getVariableValues(
		templateNumber: number,
		variableName: string
	) {
		const url = new URL(`${ PRODUCT_TEMPLATE_URL }/${ templateNumber }/${ variableName }`);
		return this.http.get<TemplateVariableValues>(url.toString());
	}

	getMappedConfiguration(
		configurationNumber: string,
		translationType?: TranslationType
	) {
		const productUrl = new URL(`${ CONFIGURATIONS_URL }/${ configurationNumber }`);
		const params = productUrl.searchParams;
		if (translationType !== undefined) {
			params.append('translation', String(translationType));
		}
		return this.http.get<DataWithTranslation<ProductConfiguration>>(productUrl.toString()).pipe(map(
			product => {
				this.productCharacteristicsTranslationService.add(product.translations);
				return product.data;
			}
		));
	}

	simulateTemplateProduct(
		templateSimulationRequest: ProductConfiguration | FieldValueObject,
		translationType?: TranslationType
	) {
		const url = new URL(SIMULATE_CONFIGURATIONS_URL);
		const params = url.searchParams;
		if (translationType !== undefined) {
			params.append('translation', String(translationType));
		}
		return this.http.post<DataWithTranslation<UfoProductSimulationResponse>>(
			url.toString(),
			templateSimulationRequest
		).pipe(
			tap(
				rsp => {
					this.productCharacteristicsTranslationService.add(rsp.translations);
				}
			),
			map(
				rsp => rsp.data
			)
		);
	}
}
